const LayoutConfig2 = {
    defaults: {
        navbar: {
          display: true,
          folded: true,
          position: 'left',
        },
        toolbar: {
          display: false,
          style: 'fixed',
        },
        footer: {
          display: true,
          style: 'fixed',
        },
        leftSidePanel: {
          display: true,
        },
        rightSidePanel: {
          display: true,
        },
      }
}
export default LayoutConfig2